import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Reply, Edit, AddReactionOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTheme } from '@ublend-npm/aulaui-core';
import { DARK } from '@core/constants/theme';
import { MessageMenuContainer } from './MessageMenu.styled';
import StyledTooltip from '../common/StyledTooltip';

const MessageMenu = ({
  messageId,
  editMessage,
  replyToMessage,
  openEmojiPicker,
}) => {
  const { palette } = useTheme();
  const handleOpenPicker = (e) => {
    openEmojiPicker({
      messageId,
      anchor: e.currentTarget,
    });
  };

  const [isFocusing, setFocusing] = useState(false);

  return (
    <MessageMenuContainer
      isFocusing={isFocusing}
      onFocus={() => setFocusing(true)}
      onBlur={() => setFocusing(false)}
      bgColor={palette.mode === DARK ? 'transparent' : '#fff'}
    >
      <StyledTooltip title="React to message" position="bottom">
        <div style={{ marginTop: '2px' }} role="presentation">
          <IconButton
            onClick={handleOpenPicker}
            label="reply"
            size="small"
            buttonAttributes={{
              tabIndex: -1,
            }}
          >
            <AddReactionOutlined />
          </IconButton>
        </div>
      </StyledTooltip>
      <StyledTooltip title="Reply to message" position="bottom">
        <div style={{}} role="presentation">
          <IconButton
            onClick={replyToMessage}
            label="reply"
            size="small"
            buttonAttributes={{
              tabIndex: -1,
            }}
          >
            <Reply />
          </IconButton>
        </div>
      </StyledTooltip>
      {editMessage && (
        <StyledTooltip title="Edit message" position="bottom">
          <div style={{ marginTop: '3px' }} role="presentation">
            <IconButton
              size="small"
              label="edit"
              onClick={editMessage}
              buttonAttributes={{
                tabIndex: -1,
              }}
            >
              <Edit />
            </IconButton>
          </div>
        </StyledTooltip>
      )}
    </MessageMenuContainer>
  );
};

MessageMenu.propTypes = {
  messageId: PropTypes.string.isRequired,
  editMessage: PropTypes.func,
  replyToMessage: PropTypes.func.isRequired,
  openEmojiPicker: PropTypes.func.isRequired,
};

MessageMenu.defaultProps = {
  editMessage: null,
};

export default React.memo(MessageMenu);
